enum PlayableSpec {
  Moonkin,
  FireMage
}

export default PlayableSpec
